import { memo, useMemo } from "react";
import type { FC, ReactNode } from "react";
import { Box, Paper, Typography, useTheme, Theme, SxProps } from "@mui/material";
import getStyles from "./styles";

type Props = {
  title?: string;
  children?: ReactNode;
  sx?: SxProps<Theme>;
};

const Section: FC<Props> = ({ title, children, sx }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <Box component="section" sx={sx} className="RlxSection">
      {title && (
        <Typography variant="h2" sx={styles.title} className="RlxSection-title">
          {title}
        </Typography>
      )}
      <Paper sx={styles.card} className="RlxSection-content">
        {children}
      </Paper>
    </Box>
  );
};

Section.displayName = "Section";

export default memo(Section);
